import { SearchOption, ApiContentType } from '../types/search';

export const SEARCH_OPTIONS: SearchOption[] = [
  { 
    id: 'video',
    label: 'search.videos',
    icon: 'ph:video-camera-thin',
    apiConfig: {
      endpoint: 'content',
      params: { type: 'Video' }
    }
  },
  { 
    id: 'shorts',
    label: 'search.shorts',
    icon: 'ph:play-circle-thin',
    apiConfig: {
      endpoint: 'content',
      params: { 
        type: 'Video',
        duration: '0-5'
      }
    }
  },
  { 
    id: 'lives',
    label: 'search.lives',
    icon: 'ph:broadcast-thin',
    apiConfig: {
      endpoint: 'lives'
    }
  },
  { 
    id: 'topics',
    label: 'search.topics',
    icon: 'ph:book-open-thin',
    apiConfig: {
      endpoint: 'topics'
    }
  },
  { 
    id: 'audio',
    label: 'search.audio',
    icon: 'ph:microphone-thin',
    apiConfig: {
      endpoint: 'content',
      params: { type: 'Audio' }
    }
  },
];

export const DEFAULT_SEARCH_TYPE = 'video';

export const SEARCH_DEBOUNCE_MS = 300;

export const SEARCH_RESULT_LIMIT = 20;

export const FILTER_OPTIONS = {
  DURATION: [
    { value: '0-5', translationKey: 'search.duration.range', min: 0, max: 5 },
    { value: '5-20', translationKey: 'search.duration.range', min: 5, max: 20 },
    { value: '20-60', translationKey: 'search.duration.range', min: 20, max: 60 },
    { value: '60', translationKey: 'search.duration.overMinutes', min: 60 }
  ],
  SORT: [
    { value: 'title' as const, translationKey: 'search.sort.title' },
    { value: 'date' as const, translationKey: 'search.sort.date' },
    { value: 'duration' as const, translationKey: 'search.sort.duration' }
  ],
  SORT_DIRECTION: {
    ASC: 'asc' as const,
    DESC: 'desc' as const
  }
} as const;

export const API_ENDPOINTS = {
  CONTENT: 'content',
  LIVES: 'lives',
  TOPICS: 'topics'
} as const;

export const API_CONTENT_TYPES: Record<string, ApiContentType> = {
  VIDEO: 'Video',
  AUDIO: 'Audio',
  LIVE: 'Live'
} as const;

export const UI_SETTINGS = {
  SEARCH_DEBOUNCE_MS: 300,
  MOBILE_BREAKPOINT: 1024,
  MIN_SEARCH_CHARS: 2
} as const; 